export const LIST = 'LIST';
export const ITEM = 'ITEM';



// WEBPACK FOOTER //
// ./src/store/modules/notification/mutation-types.js